import { NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'wk8-claw-back',
  imports: [NgStyle],
  templateUrl: './wk8-claw-back.component.html',
  styleUrl: './wk8-claw-back.component.css',
})
export class Wk8ClawBackComponent {
  readonly spritePath = 'assets/woordkr8/sprites/';
  opened = input(false);
  size = input(1);
}
